import { render, staticRenderFns } from "./AdminSettingItemPopup.vue?vue&type=template&id=33f6a610&scoped=true&"
import script from "./AdminSettingItemPopup.vue?vue&type=script&lang=js&"
export * from "./AdminSettingItemPopup.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingItemPopup.vue?vue&type=style&index=0&id=33f6a610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f6a610",
  null
  
)

export default component.exports